//import MyList from "@tw/customer-identity-cra/lib/home/home-master-nextjs";
import SharedProduct from "@tw/customer-identity-cra/lib/mylist/sharedProducts/sharedProducts-master-nextjs.js";
import PageWrapper from "../../../wrappers/page-wrapper";

SharedProduct.domainName = "customer-identity";

export default PageWrapper(SharedProduct);